module.exports = __webpack_public_path__ + "static/media/nav_left_myprojects.484d467c.svg";